import Request from './request'
import consts from '@/consts.js'


async function fetchAllForSelect (data) {
  if (!data) data = {}
  data.limit = consts.limitAll //获取全部
  data.fieldFilter = [
      "id",
      "code",
      "name",
      "stock_area",
      "stock_roadway_setting",
      "stock_district_code",
      "position_name_display"
  ]; //仅筛选少许必要字段

  return Request('get', 'api/stocks/select', data, false, false, true)
}

async function fetchOne (id) {
  // 获取单个
  return Request('get', 'api/stocks/' + id)
}

export default {
  fetchAllForSelect,
  fetchOne,
}
